// Node Imports 
import React, { useState, useEffect, useContext } from 'react'
import moment from 'moment'
import Utilities from '../../../../../services/commonservice/utilities'

// Template imports 
import List from '../../../../templates/components/List'
import label from '../../../../../../assets/i18n/en.json'

// Service imports 
import AppointmentService from '../../../../../services/api/appointment.service'
import StorageService from '../../../../../services/session/storage.service'
import AppointmentCard from './AppointmentCard'
import { store } from '../../../../../context/StateProvider'
import PracticeLocationSelector from '../../../../templates/components/PracticeLocationSelector'
import Table2 from '../../../../templates/components/Table2'

const tableColumns = [
    {
        id: "date",
        Header: "Date",
        accessor: (row) => {
            let dateText = row.fromDate ? moment(row.fromDate).format("MM-DD-YYYY") : "";
            if (row.providerRequested === 1) {
                dateText = "R " + dateText;
            }
            return dateText;
        }
    },
    {
        id: "time",
        Header: "Time",
        accessor: (row) => {
            return row.fromDate ? `${moment(row.fromDate).format('h:mm')}-${moment(row.toDate).format('h:mm A')}` : ""
        }
    },
    {
        id: "doctorId",
        Header: "Provider",
        accessor: (row) => {
            return row.drFirstName ? `${row.drFirstName} ${row.drLastName}` : ""
        }
    },
    {
        id: "appointmentStatusCode",
        Header: "Status",
        accessor: (cell) => cell.appointmentStatusCode || "",
    }, {
        id: "practiceServiceType",
        Header: "Service",
        accessor: (cell) => cell.practiceServiceType || "",
    },
    {
        id: "practiceLocation",
        Header: "Practice Location",
        accessor: (cell) => cell.practiceLocation || "",
    },
    {
        id: "memo",
        Header: "Note",
        accessor: (cell) => cell.memo || "",
    }
];

const TodaysAppointments = (props) => {
    // Context items 
    const stateAndDispatch = useContext(store)
    const state = stateAndDispatch.state

    // States 
    const [isLoading, setIsLoading] = useState(true)
    const [appointments, setAppointments] = useState()
    const [noRecordsFound, setNoRecordsFound] = useState([])
    const [fromDate, setFromDate] = useState(Utilities.representLocalDateAsUTCMidnightISO(new Date(moment().startOf('d'))))
    const [toDate, setToDate] = useState(Utilities.representLocalDateAsUTCMidnightISO(new Date(moment().add(1, 'd').startOf('d'))))
    const [locationId, setLocationId] = useState()
    // const [metrics, setMetrics] = useState()

    const [doctorId, setDoctorId] = useState('uninitialized')
    useEffect(() => {
        let data = JSON.parse(StorageService.get('session', 'userDetails'))
        setDoctorId(data.doctorId)
    }, [])

    useEffect(() => {
        if (props.refreshAppointments) {
            handleRefresh();
        }
    }, [props.refreshAppointments]);

    useEffect(() => {
        if (state.practiceLocationId) {
            setLocationId(state.practiceLocationId)
        }
    }, [state.practiceLocationId])

    const onLocationChanged = (newLocationId) => {
        setLocationId(newLocationId)
    }
    // Get today's Appoitment
    const getAppointment = () => {
        if (props.setPatients) {
            props.setPatients()
        }
        setIsLoading(true)
        let reqObj = {}
        reqObj.FromDate = fromDate;
        reqObj.ToDate = toDate;
        reqObj.SortField = 'ToDate'
        reqObj.Asc = true
        reqObj.Location = locationId
        if (props.providerId) {
            reqObj.DoctorIds = props.providerId
        }
        //let metrics = { upcoming: 0, checkedIn: 0, withProvider: 0, checkedOut: 0 }
        return AppointmentService.findAppointment(reqObj)
            .then((findAppointmentResponse) => {
                let patientList = []
                let appointmentList = findAppointmentResponse.filter(obj => obj.id)
                if (appointmentList.length === 0) {
                    setAppointments();
                    setNoRecordsFound(true)
                } else {
                    setNoRecordsFound(false)
                    let localDoctorId = doctorId
                    if (doctorId == 'uninitialized') {
                        let data = JSON.parse(StorageService.get('session', 'userDetails'))
                        setDoctorId(data.doctorId)
                        localDoctorId = data.doctorId
                    }
                    if (localDoctorId) {
                        appointmentList = appointmentList.filter(x => x.doctorId == localDoctorId);
                    }
                    appointmentList.forEach(element => {
                        patientList.push(element.patientId)
                        let fullName = '';
                        fullName = (element.firstName != null) ? `${fullName} ${element.firstName}` : `${fullName}`;
                        fullName = (element.lastName != null) ? `${fullName} ${element.lastName}` : `${fullName}`;
                        element.fullName = fullName;
                    })
                    //added logic to arrange child under parent appt.
                    let arrangedAppointments = arrangeAppointments(appointmentList)
                    setAppointments(arrangedAppointments)
                    if (props.setPatients) {
                        props.setPatients(patientList)
                    }
                }
                return setIsLoading(false)
            })
            .catch(err => {
                setIsLoading(false)
            });
    }
    const arrangeAppointments = (appointments) => {
        //store parent-child relationships
        let appointmentMap = new Map();
        let parents = [];
        appointments.forEach(appointment => {
            if (appointment.parentGroupId === "") {
                parents.push(appointment);
            } else {
                //store child in the map
                if (!appointmentMap.has(appointment.parentGroupId)) {
                    appointmentMap.set(appointment.parentGroupId, []);
                }
                appointmentMap.get(appointment.parentGroupId).push(appointment);
            }
        });
        //Sort parent appointments by fromDate
        parents.sort((a, b) => new Date(a.fromDate) - new Date(b.fromDate));
        //Insert children after their respective parents
        let finalResult = [];
        parents.forEach(parent => {
            finalResult.push(parent);
            if (appointmentMap.has(parent.id)) {
                finalResult.push(...appointmentMap.get(parent.id).sort((a, b) => new Date(a.fromDate) - new Date(b.fromDate))); // Sort children
            }
        });
        return finalResult;
    }

    useEffect(() => {
        if (locationId) {
            if (props.providerPage && !props.providerId) {
                setAppointments()
            }
            else {
                handleRefresh()
            }
        }
    }, [locationId, props.providerId])

    const handleRefresh = ()=>{
        setAppointments()
        getAppointment()
    }
    return (
        <div>

            {isLoading &&
                <div className="ui active dimmer">
                    <div className="ui indeterminate text loader">{label.common.loading}</div>
                </div>}
            <div className="row p-3 pt-0">
                <div className='primary-header d-flex justify-content-between align-items-center row ms-0 mb-3'>
                    <div className='col-md-auto col-12'>
                        {moment().format("dddd, MMMM, D")}
                    </div>
                    <div className="col-md-auto ms-auto d-flex align-items-center gap-3">
                        <PracticeLocationSelector onSelected={onLocationChanged} />

                        <Table2
                            data={appointments && fromDate && appointments.filter(obj => obj.visitStatus !== 3)}
                            columns={tableColumns}
                            loading={props?.loading}
                            export
                            hidden={true}
                            title="Todays Appointments"
                        />
                    </div>
                </div>
                <List
                    hideSortBy
                    // pageSize={10}
                    className='scroll-list mt-0'
                    noPaginate
                    noResultsMessage="There are no additional appointments for today"
                    style={{ maxHeight: '80vh' }}
                >
                    {(appointments && fromDate) && appointments
                        .filter(obj => obj.visitStatus !== 3)
                        .map((appointment, i) => {
                            return (
                                <div key={i}><AppointmentCard appointment={appointment} refresh={handleRefresh} /></div>
                            )
                        })}
                </List>
            </div>
        </div>

    )
}

export default TodaysAppointments